module.exports = __webpack_public_path__ + "static/media/notfound-bg.4beb6c88.jpeg";